/* eslint-disable */

import { FuseNavigationItem } from '@fuse/components/navigation';


// ==========================================
// Get Client Name From apiURL
// ==========================================

const getClientName = (): string => {

    const apiUrl = localStorage.getItem('apiURL');

    if (!apiUrl)
        return '';

    try {

        const hostname = new URL(apiUrl).hostname;

        // مثال:
        // api-admin.mazagelmeluk.egtruetech.cloud

        const parts = hostname.split('.');
        return parts.length >= 2
            ? parts[1].toLowerCase()
            : '';

    } catch {

        return '';
    }
};


const clientName = getClientName();

// ==========================================
// Default Navigation
// ==========================================

export const defaultNavigation: FuseNavigationItem[] = [

    {
        id   : 'example',
        title: 'Products',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/products'
    }

];


// ==========================================
// Compact Navigation
// ==========================================

export const compactNavigation: FuseNavigationItem[] = [

    {
        id   : 'Dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : '/home'
    },

    {
        id   : 'products',
        title: 'Products',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/admin/products'
    },

    {
        id   : 'categories',
        title: 'Categories',
        type : 'basic',
        icon : 'heroicons_outline:tag',
        link : '/admin/categories'
    },

    {
        id   : 'brands',
        title: 'Brands',
        type : 'basic',
        icon : 'heroicons_outline:cube-transparent',
        link : '/admin/brands'
    },

    {
        id   : 'units',
        title: 'Units',
        type : 'basic',
        icon : 'heroicons_outline:inbox-stack',
        link : '/admin/units'
    },

    {
        id   : 'variants',
        title: 'Variants',
        type : 'basic',
        icon : 'heroicons_outline:lifebuoy',
        link : '/admin/variants'
    },

    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/admin/users'
    },

    {
        id   : 'orders',
        title: 'Orders',
        type : 'basic',
        icon : 'heroicons_outline:shopping-cart',
        link : '/admin/orders'
    },


    // ==========================================
    // MAZAGELMELUK ONLY
    // ==========================================

    ...((clientName === 'allinz' || clientName === '') 
        ? [
            // {
            //     id   : 'reservations',
            //     title: 'Reservations',
            //     type : 'basic' as const,
            //     icon : 'heroicons_outline:bookmark-square',
            //     link : '/admin/reservations'
            // },
            // {
            //     id   : 'MenuDays',
            //     title: 'MenuDays',
            //     type : 'basic' as const,
            //     icon : 'heroicons_outline:arrow-down-tray',
            //     link : '/admin/MenuDays'
            // }
            {
        id   : 'Coupons',
        title: 'Coupons',
        type : 'basic' as const,
        icon : 'heroicons_outline:banknotes',
        link : '/admin/coupons'
    },
    {
        id   : 'Locations',
        title: 'Locations',
        type : 'basic' as const,
        icon : 'heroicons_outline:map-pin',
        link : '/admin/location'
    }
        ]
        : []
    ),
    
    {
        id   : 'Gallary',
        title: 'Gallary',
        type : 'basic',
        icon : 'heroicons_outline:photo',
        link : '/admin/gallery'
    },

    {
        id   : 'Banners',
        title: 'Banners&Sliders',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/admin/banners'
    },

    {
        id   : 'BusinessSettings',
        title: 'Business Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-6-tooth',
        link : '/admin/business'
    }

];